import { styled } from 'linaria/react';
import { theme } from '../Theme/Theme';

export const Section = styled.section`
  padding-top: ${theme.spacing.sectionMarginTop};
`;
